import tokens from '@ifood/pomodoro-tokens';
import { Link as BaseGatsbyLink } from 'gatsby-plugin-intl';
import { Link as BaseReactScrollLink } from 'react-scroll';
import styled, { css } from 'styled-components';

const LinkStyles = css`
  color: ${tokens.colors.primary};
  font-weight: 400;
  text-decoration: none;
`;

export const ReactScrollLink = styled(BaseReactScrollLink)`
  ${LinkStyles};
`;

export const GatsbyLink = styled(BaseGatsbyLink)`
  ${LinkStyles};
`;

export const NormalLink = styled.a`
  ${LinkStyles};
`;
